import React, { useState, useEffect } from 'react';
import { X, Maximize2 } from 'lucide-react';

export const DIWALI_POSTER = '/api/upload/images/diwali-gala-2026-hero.jpg';
export const DIWALI_DETAILS_FLYER = '/api/upload/images/diwali-gala-2026-details.jpg';
const GOLD = '#C9A86C';

const DiwaliPoster = ({ className = '', testId = 'diwali-poster', src = DIWALI_POSTER, alt = 'Brick Lane Diwali Gala 2026 — save the date, November 6 and 7' }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="View the Diwali Gala 2026 invitation full size"        className={`relative block w-full p-2 group cursor-zoom-in ${className}`}
        style={{ border: `1px solid ${GOLD}` }}
        data-testid={testId}
      >
        <img
          src={src}
          alt={alt}
          className="w-full h-auto transition-opacity duration-300 group-hover:opacity-80"
        />
        <span
          className="absolute bottom-5 right-5 inline-flex items-center gap-2 px-3 py-2 text-[10px] uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ backgroundColor: GOLD, color: '#0a0a0a' }}
        >
          <Maximize2 size={13} /> Enlarge
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 cursor-zoom-out"
          style={{ backgroundColor: 'rgba(0,0,0,0.94)' }}
          onClick={() => setOpen(false)}
          data-testid="diwali-poster-lightbox"
        >
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label="Close"
            className="absolute top-5 right-5 text-white/70 hover:text-white transition-colors"
            data-testid="diwali-poster-lightbox-close"
          >
            <X size={30} />
          </button>
          <img
            src={src}
            alt={alt}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full w-auto h-auto object-contain cursor-default"
            style={{ border: `1px solid ${GOLD}`, maxHeight: 'calc(100vh - 3rem)' }}
            data-testid="diwali-poster-lightbox-image"
          />
        </div>
      )}
    </>
  );
};

export default DiwaliPoster;
